<fgb-banner [pageTitle]="'faq.page.title'"></fgb-banner>

<fgb-page-header [showBalance]="false" [pageTitle]="'faq.page.title'" [backButtonLink]="'/'" />

<div class="container">
  <fgb-upgrade-banner></fgb-upgrade-banner>
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
